import React from 'react'
import classNames from 'classnames'
import { SliderPaginationProps } from './SliderPagination.d'

const SliderPagination = ({ classes = '' }: SliderPaginationProps) => {
  const paginationClasses = classNames(
    'swiper-pagination mt-4 !relative z-auto',
    classes
  )
  return <div className={paginationClasses} data-testid='SliderPagination' />
}

export default SliderPagination
